if (!customElements.get('buy-box')) {
  class BuyBox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('.buy-box__form');
      this.additionalItems = [];

      const additionalItemsScript = this.querySelector('[data-additional-items]');
      if (additionalItemsScript) {
        this.additionalItems = JSON.parse(additionalItemsScript.innerHTML);
      }

      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(evt) {
      evt.preventDefault();

      const config = {
        method: 'POST',
        headers: { Accept: `application/javascript`, 'X-Requested-With': 'XMLHttpRequest' },
      };

      const formData = new FormData(this.form);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          window.location = '/checkout';
        })
        .catch(error => console.error(error));
    }
  }

  customElements.define('buy-box', BuyBox);
}